import * as _ from 'lodash';
import { ChatMessageType } from '../../const/chatMessageType';
import guid from '../mini/guid';
import { mergeProgressiveMessages } from '../../../../alan_btn/src/textChat/helpers/mergeProgressiveMessages';
import { ChatMessageName } from '../../const/chatMessageName';
import { getMsgReqId } from '../../../../alan_btn/src/textChat/helpers/getMsgReqId';
import { IResponseMessage, ITextMessage } from '../../models/IChatMessage';

let messages = [];
let canceledRequests = [];
let updateTsKey = '';
const EMPTY_VS_TEXT = 'Visual state has been cleared';

const ChatMessages = {

    canMsgBeStopped: function (message: ITextMessage) {
        const respMsg = message as IResponseMessage;
        return message.name === ChatMessageName.Loading ||
            (
                message.type === ChatMessageType.Text &&
                respMsg.ctx?.final !== true &&
                message.my !== true
            )
    },

    cancelResponse: function (message) {

        const msgReqId = getMsgReqId(message);

        canceledRequests.push(msgReqId);

        for (let i = 0; i < messages.length; i++) {
            const curMsg = messages[i];
            const curMsgReqId = getMsgReqId(curMsg);

            if (ChatMessages.canMsgBeStopped(curMsg) && curMsgReqId === msgReqId) {
                messages[i].isHidden = true;
                messages[i].queryProgressUpdateTs = Date.now();
            }
        }

        window.dispatchEvent(new CustomEvent("updateChat"));
    },

    addMessage: function (message) {
        let lastMessage,
            existingMsgWasFound = false;

        const newMsgReqId = getMsgReqId(message);

        if (canceledRequests.indexOf(newMsgReqId) > -1) return;

        const allPrevVs = messages.filter((msg) => msg.type === ChatMessageType.VisualState);
        const lastVs = allPrevVs[allPrevVs.length - 1];
        lastMessage = messages[messages.length - 1];

        if (message.type !== ChatMessageType.VisualState) {
            message.visualStateIndex = lastVs && lastVs.data === EMPTY_VS_TEXT ? 0 : messages.filter((msg) => msg.type === ChatMessageType.VisualState && msg.data !== EMPTY_VS_TEXT).length;
        } else {
            message.visualStateIndex = messages.filter((msg) => msg.type === ChatMessageType.VisualState && msg.data !== EMPTY_VS_TEXT).length;
        }

        if (message.type === ChatMessageType.VisualState) {
            if (lastMessage && lastMessage.type !== ChatMessageType.VisualState && _.isEmpty(message.data)) {
                message.visualStateIndex = 0;
                this.pushMessage({ ...message, data: EMPTY_VS_TEXT });
                this.update();
                return;
            }
            if (lastMessage && lastMessage.type === ChatMessageType.VisualState && lastMessage.data === EMPTY_VS_TEXT && _.isEmpty(message.data)) {
                return;
            }
            message.visualStateIndex = _.isEmpty(message.data) ? 0 : message.visualStateIndex + 1;
            this.pushMessage(_.isEmpty(message.data) ? { ...message, data: EMPTY_VS_TEXT } : message);
            this.update();
            return;
        }

        if (
            (message.type === ChatMessageType.Reconnect && messages.length === 0) ||
            (message.type === ChatMessageType.Reconnect && lastMessage?.type === ChatMessageType.Reconnect)
        ) {
            return;
        }

        if (message.type === ChatMessageType.Reconnect && lastMessage?.type !== ChatMessageType.Reconnect) {
            messages = messages.filter(m => m.name !== ChatMessageName.Loading);

            for (let i = 0; i < messages.length; i++) {
                if (messages[i]?.ctx) {
                    messages[i].ctx.final = true;
                }
            }

            this.pushMessage(message);
            this.update();
            return;
        }

        if (messages.length === 0) {
            this.pushMessage(message);
            this.update();
            return;
        }

        if (message.type === ChatMessageType.Text &&
            message.name === ChatMessageName.Loading) {
            const loadingMsg = messages.find(m => m.ctx?.reqId === message.ctx?.reqId);
            if (loadingMsg) {
                if (message.progress?.name) {
                    if (loadingMsg.queryProgress?.length > 0) {
                        loadingMsg.queryProgress.push({
                            text: message.progress?.name,
                            isShown: false
                        })
                    } else {
                        loadingMsg.queryProgress = [{
                            text: message.progress?.name,
                            isShown: false
                        }]
                    }
                    loadingMsg.queryProgressUpdateTs = Date.now();
                }
                this.update();
                return;
            } else {
                this.pushMessage({
                    ...message,
                    queryProgress: [{
                        text: message.progress?.name,
                        isShown: false
                    }]
                });
                this.update();
                return;
            }
        }

        if (message.type === ChatMessageType.QrCode) {
            this.pushMessage(message);
            this.update();
            return;
        }

        if (message.type === ChatMessageType.Popup) {
            this.pushMessage(message);
            this.update();
            return;
        }

        if (message.type === ChatMessageType.Info) {
            this.pushMessage(message);
            this.update();
            return;
        }

        if (message.type === ChatMessageType.ConnectionState) {
            this.pushMessage(message);
            this.update();
            return;
        }

        if (message.type === ChatMessageType.Command) {
            const cmdRegId = (message.commandData.length > 0 && message.commandData[0].ctx) ? message.commandData[0].ctx.reqId : null;
            const hasStartingMsg = _.find(messages, { type: ChatMessageType.Text, reqId: cmdRegId });
            if (!hasStartingMsg) {
                return;
            }
        }

        if (message.type === ChatMessageType.Command) {
            if (messages.length === 0) {
                this.pushMessage(message);
                this.update();
                return;
            }
            lastMessage = messages[messages.length - 1];
            if (lastMessage.type !== ChatMessageType.Command) {
                this.pushMessage(message);
            } else {
                lastMessage.ui_id = guid();
                lastMessage.commandData = [
                    ...lastMessage.commandData, ...message.commandData];
            }
            this.update();
            return;
        }

        for (let i = 0; i < messages.length; i++) {
            const curMsg = messages[i];
            const curMsgReqId = curMsg.reqId || curMsg.ctx?.reqId;
            const msgReqId = message.reqId || message.ctx?.reqId;

            if (message.id && curMsg.id === message.id) {
                if (curMsg.my === message.my) {
                    messages[i] = { ...curMsg, ...message };
                    existingMsgWasFound = true;
                    break;
                }
            } else if (message.responseId && curMsg.ctx?.responseId === message.responseId) {

                mergeProgressiveMessages(messages, i, message);
                messages[i].ts = message.ts;

                if (messages[i].ctx) {
                    messages[i].ctx.final = message.ctx?.final !== undefined ? message.ctx.final : false;
                    messages[i].ctx.inspectURL = message.ctx?.inspectURL !== undefined ? message.ctx.inspectURL : undefined;
                }

                existingMsgWasFound = true;
                break;
            } else if (msgReqId && curMsgReqId === msgReqId) {
                if (
                    (curMsg.my === true && message.my === true) ||
                    (curMsg.name === ChatMessageName.Loading && message.my !== true)) {
                    messages[i] = { ...curMsg, ...message };
                    delete messages[i].name;
                    existingMsgWasFound = true;
                    break;
                }
            }
        }

        if (!existingMsgWasFound) {
            lastMessage = messages[messages.length - 1];

            if (lastMessage.type === ChatMessageType.Text &&
                lastMessage.my &&
                !lastMessage.id &&
                !lastMessage.reqId) {
                messages[messages.length - 1] = { ...lastMessage, ...message };
                existingMsgWasFound = true;
            }
        }

        if (!existingMsgWasFound) {
            this.pushMessage(message);
        }

        this.update();

        return;
    },

    updateMessageStatus(message) {
        for (let i = 0; i < messages.length; i++) {
            const curMsg = messages[i];
            const curMsgReqId = curMsg.reqId || curMsg.ctx?.reqId;
            const msgReqId = message.reqId || message.ctx?.reqId;

            if (msgReqId && curMsgReqId === msgReqId && !curMsg.my && curMsg.type === ChatMessageType.Text) {
                const index = _.findIndex(curMsg.queryProgress, { isShown: false });

                if (index >= 0) {
                    messages[i].queryProgress[index].isShown = true;
                    messages[i].queryProgressUpdateTs = Date.now();
                    this.update();
                    return messages[i].queryProgress[index].text;
                }
            }
        }
    },

    pushMessage(message) {
        const msg = { ...message, ui_id: guid() };
        messages.push(msg);
        window.dispatchEvent(new CustomEvent('newChatMessage', { detail: { message: msg } }));
    },

    getMessages: () => {
        return messages;
    },

    update: function () {
        updateTsKey = `${Date.now()}_${messages.length}`;
    },

    clear: () => {
        messages = [];
    }
};
export default ChatMessages;
